import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CodeTableEntry } from 'domain/components/codetable/CodeTableOptions';
import {
  FormControl,
  FormGroup,
  FormLabel,
  FormText,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import { Field } from 'react-final-form';
import WhenFieldChanges, { WhenFieldChangesProps } from './WhenFieldChanges';

type IFinalFormField = {
  name: string;
  label: string | null | undefined;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  when?: WhenFieldChangesProps;
  onKeyDown?: (value: string) => boolean;
  validate?: (value: string) => string | undefined;
  text?: string;
  info?: string;
  defaultValue?: string;
} & (
  | { type?: 'text' | 'number' | 'email' }
  | {
      type: 'select';
      options: CodeTableEntry[];
    }
);

const FinalFormField = (props: IFinalFormField) => {
  return (
    <>
      <Field
        name={props.name}
        validate={props.validate}
        defaultValue={props.defaultValue}
      >
        {({ input, meta }) => (
          <FormGroup className={props.className}>
            {props.label && (
              <FormLabel
                htmlFor={props.name}
                className={props.info ? 'd-inline-block mr-3' : undefined}
              >
                {props.label}
              </FormLabel>
            )}
            {props.info && (
              <OverlayTrigger
                overlay={<Tooltip id={props.name}>{props.info}</Tooltip>}
              >
                <FontAwesomeIcon icon={faInfoCircle} />
              </OverlayTrigger>
            )}
            <FormControl
              id={props.name}
              className={meta.error ? 'is-invalid' : undefined}
              type={props.type}
              as={props.type === 'select' ? 'select' : undefined}
              disabled={props.disabled}
              onKeyDown={(
                e: React.KeyboardEvent<HTMLInputElement | HTMLSelectElement>
              ) => {
                if (e.key === 'Backspace') return true;
                if (props.onKeyDown) {
                  if (!props.onKeyDown(e.key)) {
                    e.preventDefault();
                  }
                }
              }}
              {...(props.type !== 'select' && {
                placeholder: props.placeholder,
              })}
              {...input}
            >
              {props.type === 'select' && props.options
                ? props.options.map((e) => (
                    <option key={e.cd} value={e.cd}>
                      {e.descr}
                    </option>
                  ))
                : undefined}
            </FormControl>
            {props.text && (
              <FormText className='text-muted'>{props.text}</FormText>
            )}
            {meta.error && (
              <FormControl.Feedback type='invalid' className='d-block'>
                {meta.error}
              </FormControl.Feedback>
            )}
          </FormGroup>
        )}
      </Field>
      {props.when && <WhenFieldChanges {...props.when} />}
    </>
  );
};

export default FinalFormField;
